export type Airport = {
  code: string;
  cityFa: string;
  cityEn: string;
  airportFa?: string;
  airportEn?: string;
};

export const fallbackAirports: Airport[] = [
  { code: 'THR', cityFa: 'تهران', cityEn: 'Tehran', airportFa: 'مهرآباد', airportEn: 'Mehrabad' },
  { code: 'IKA', cityFa: 'تهران', cityEn: 'Tehran', airportFa: 'امام خمینی', airportEn: 'Imam Khomeini' },
  { code: 'MHD', cityFa: 'مشهد', cityEn: 'Mashhad', airportFa: 'هاشمی‌نژاد', airportEn: 'Hasheminejad' },
  { code: 'IFN', cityFa: 'اصفهان', cityEn: 'Isfahan', airportFa: 'شهید بهشتی', airportEn: 'Shahid Beheshti' },
  { code: 'KER', cityFa: 'کرمان', cityEn: 'Kerman' },
  { code: 'SYZ', cityFa: 'شیراز', cityEn: 'Shiraz' },
  { code: 'TBZ', cityFa: 'تبریز', cityEn: 'Tabriz' },
  { code: 'AWZ', cityFa: 'اهواز', cityEn: 'Ahvaz' },
  { code: 'KIH', cityFa: 'کیش', cityEn: 'Kish' },
  { code: 'BND', cityFa: 'بندرعباس', cityEn: 'Bandar Abbas' },
  { code: 'IST', cityFa: 'استانبول', cityEn: 'Istanbul' },
  { code: 'SAW', cityFa: 'استانبول', cityEn: 'Istanbul', airportFa: 'صبیحه', airportEn: 'Sabiha' },
  { code: 'DXB', cityFa: 'دبی', cityEn: 'Dubai' },
  { code: 'NJF', cityFa: 'نجف', cityEn: 'Najaf' },
];

const knownAirports: Record<string, Omit<Airport, 'code'>> = {
  ...Object.fromEntries(fallbackAirports.map(({ code, ...names }) => [code, names])),
  ADB: { cityFa: 'ازمیر', cityEn: 'Izmir' },
  ISE: { cityFa: 'اسپارتا', cityEn: 'Isparta' },
  AYT: { cityFa: 'آنتالیا', cityEn: 'Antalya' },
  BGW: { cityFa: 'بغداد', cityEn: 'Baghdad' },
};

const iranianAirports = new Set([
  'THR', 'IKA', 'MHD', 'IFN', 'KER', 'SYZ', 'TBZ', 'AWZ', 'KIH', 'BND',
]);

export function toAirport(code: string): Airport {
  return { code, ...(knownAirports[code] ?? { cityFa: code, cityEn: code }) };
}

export function isIranianAirport(code: string): boolean {
  return iranianAirports.has(code);
}

/** "تهران (مهرآباد)" when the airport name differs from the city. */
export function airportPlace(airport: Airport, isFa: boolean): string {
  const city = isFa ? airport.cityFa : airport.cityEn;
  const name = isFa ? airport.airportFa : airport.airportEn;
  if (!name || name === city) return city;
  return `${city} (${name})`;
}

export function cityName(code: string, isFa: boolean): string {
  const airport = toAirport(code);
  return isFa ? airport.cityFa : airport.cityEn;
}

export function isInternationalRoute(origin: string, destination: string): boolean {
  return !iranianAirports.has(origin) || !iranianAirports.has(destination);
}
